import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";

@Injectable()
export class NoticeBoardService {
  constructor(private db: AngularFireDatabase) {}
  getBulletins(communityId): Observable<Array<any>> {
    return this.db.list(`/messages/${communityId}`).valueChanges() || Observable.of([]);
  }

  getBulletinById(communityId, bulletinId): any {
    return this.db.object(`/messages/${communityId}/${bulletinId}`).valueChanges();
  }

  create(communityId, bulletin): any {
    const messagesRef = this.db.list(`/messages/${communityId}`);

    return messagesRef.push(bulletin).then(data => messagesRef.update(data.key, { id: data.key }));
  }

  update(communityId, bulletin): any {
    return this.db.list(`/messages/${communityId}`).update(bulletin.id, bulletin);
  }

  delete(communityId, bulletinId): any {
    return this.db.list(`/messages/${communityId}/${bulletinId}`).remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/notice-board/notice-board.service.ts